import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import AvatarOne from '../../../../Components/AvatarOne/AvatarOne'
import { Info, Send } from '@mui/icons-material'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { useContext, useState } from 'react'
import PessoalInfoModal from '../../../../Components/PessoalInfoModal/PessoalInfoModal'
import EnviarMsgModal from '../../../../Components/EnviarMsgModal/EnviarMsgModal'
import ListClickToCall from './ListClickToCall'
import { keyframes } from '@emotion/react'

const CardPessoaLista = ({ pessoa, ramalImovel, imovelSelecionado = false, tipo_licenca_cond = false }) => {
    const { addMoradorSelecionado, nomeMoradorBusca, mudaImovelSelecionado } = useContext(VisitantesContext)
    const [openInfoPessoa, setOpenInfoPessoa] = useState(false)
    const [openEnviarMsg, setOpenEnviarMsg] = useState(false)

    return (
        <Grid sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '35px',
            // border: '1px solid black',
            margin: '5px',
            borderRadius: '5px',
            alignItems: 'space-between',
            justifyContent: 'space-between',
            alignContent: 'space-between',
            padding: '5px',
            cursor: 'pointer',
            backgroundColor: 'white',
            boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.322)'
        }}>
            {openInfoPessoa &&
            <PessoalInfoModal
                openInfoPessoa={openInfoPessoa}
                setOpenInfoPessoa={setOpenInfoPessoa}
                pessoa={pessoa}
                facial={false}
            />
            }
            {openEnviarMsg &&
            <EnviarMsgModal
                openEnviarMsg={openEnviarMsg}
                setOpenEnviarMsg={setOpenEnviarMsg}
                pessoa={pessoa}
            />
            }
            <Grid onClick={() => { mudaImovelSelecionado(imovelSelecionado); setTimeout(() => { addMoradorSelecionado(pessoa) }, 100) }}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    alignItems: 'space-between',
                    justifyContent: 'space-between',
                    height: '100%'
                }}
            >
                <Grid xs={12} container direction='column' justifyContent='center' alignContent='flex-start'>
                    <Grid xs={0.4}>
                        <Typography fontWeight={'bold'} sx={ TypographySx }>{pessoa.prioridade}</Typography>
                    </Grid>
                    <Grid xs={0.6}>
                        <AvatarOne borda={false} height={'30px'} width={'30px'} src={`${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${pessoa.IMAGEMPERFIL}`}/>
                    </Grid>
                    <Grid xs={7}>
                        {
                            negritoNomeMorador(pessoa.nome, nomeMoradorBusca)
                        }
                    </Grid>
                    <Grid xs={4}>
                        <Typography fontWeight={'bold'} title={pessoa.vinculo} sx={TypographySx}>
                            {pessoa.vinculo}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={2} sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-around'
            }}>
                <Info onClick={() => setOpenInfoPessoa(true)} sx={{
                    ...IconSx,
                    color: pessoa.obs && pessoa.obs != ''
                        ? 'red'
                        : 'black',
                    animation: pessoa.obs && pessoa.obs != '' ? `${blinkAnimation} 1s 3` : 'none'
                }}
                />
                <ListClickToCall pessoa={pessoa} ramalImovel={ramalImovel} tipo_licenca_cond={tipo_licenca_cond}></ListClickToCall>
                <Send sx={IconSx} onClick={() => { setOpenEnviarMsg(true) }} />
            </Grid>
        </Grid>
    )
}

export default CardPessoaLista

const TypographySx = {
    color: 'black',
    fontSize: '13px',
    fontWeight: '500',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
    textAlign: 'center',
    paddingLeft: '5px',
    paddingRight: '5px',
    boxSizing: 'border-box'
}

export const IconSx = {
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '25px',
    height: '20px',
    cursor: 'pointer'
}

const blinkAnimation = keyframes`
    0% {
        color: red;
    }
    33% {
        color: blue;
    }
    66% {
        color: red;
    }
    100% {
        color: red;
    }
`

// Função para destacar palavras correspondentes no nome
const negritoNomeMorador = (nome, nomeMoradorBusca) => {
    // Converter a consulta de busca para minúsculas e dividir em palavras individuais
    const palavrasBusca = nomeMoradorBusca.toLowerCase().split(' ')

    // Dividir o nome em partes com base nas palavras correspondentes encontradas na busca
    const partes = nome.split(new RegExp(`(${palavrasBusca.join('|')})`, 'gi'))

    // Retornar o nome com as palavras correspondentes destacadas
    return (
        <Typography title={nome} sx={ TypographySx }>
            {partes.map((parte, i) =>
                // Se a parte for uma palavra correspondente, aplicar negrito e cor azul
                palavrasBusca.includes(parte.toLowerCase())
                    ? <span key={i} style={{ fontWeight: 'bold', color: 'blue' }}>{parte}</span>
                    : parte
            )}
        </Typography>
    )
}
